module.exports = __webpack_public_path__ + "static/media/satellite-map.69849871.png";